export default __webpack_public_path__ + "static/media/dog.ab29791f.jpg";